import { IPropostaKanbanTag } from "../types/proposta";

const NOVA_PROPOSTA_TAG: IPropostaKanbanTag = {
  label: "Nova Proposta",
  color: "#6B7280",
};

export default function PropostaStatusTag({
  tag,
}: {
  tag?: IPropostaKanbanTag | null;
}) {
  const resolved = tag ?? NOVA_PROPOSTA_TAG;

  return (
    <div className="flex justify-end mb-3">
      <span
        className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-white text-xs font-semibold shadow-sm"
        style={{ backgroundColor: resolved.color }}
      >
        {resolved.icon ? (
          <i className={`${resolved.icon} text-[11px]`} aria-hidden />
        ) : null}
        {resolved.label}
      </span>
    </div>
  );
}
